import {
  getListTopEarningArtist,
  getListTopCountry,
  getEarningToDate,
  getPopularSong,
  getPopularAlbum,
  getWeeklyCustomer,
  getSoldSong,
  getArtistBalance,
  getTopSubscriberCountry,
  getWeeklySubscriber,
  getPopularAlbumByPlay,
  getPopularSongByPlay,
} from '@/services/statistic';

const getters = {
  listWeeklyCustomer: state => state.listWeeklyCustomer,
  listSoldSong: state => state.listSoldSong,
  listPopularSong: state => state.listPopularSong,
  listPopularSongCurrent: state => state.listPopularSongCurrent,
  listPopularSongByPlay: state => state.listPopularSongByPlay,
  listPopularSongCurrentByPlay: state => state.listPopularSongCurrentByPlay,
  listPopularAlbum: state => state.listPopularAlbum,
  listPopularAlbumCurrent: state => state.listPopularAlbumCurrent,
  listPopularAlbumByPlay: state => state.listPopularAlbumByPlay,
  listPopularAlbumCurrentByPlay: state => state.listPopularAlbumCurrentByPlay,
  listTopCountry: state => state.listTopCountry,
  listTopEarningArtist: state => state.listTopEarningArtist,
  listTopSubscriberCountry: state => state.listTopSubscriberCountry,
  listWeeklySubscriber: state => state.listWeeklySubscriber,
  earningToDate: state => state.earningToDate,
  artistBalance: state => state.artistBalance,
};

const actions = {
  async requestListWeeklyCustomer({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const response = await getWeeklyCustomer({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist);
      commit('SET_WEEKLY_CUSTOMER', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListSoldSong({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const response = await getSoldSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist);
      commit('SET_SOLD_SONG', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListPopularSong({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const popularSong = await getPopularSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist, 1);
      const popularSongCurrent = await getPopularSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist, 0);
      commit('SET_LIST_POPULAR_SONG', popularSong);
      commit('SET_LIST_POPULAR_SONG_CURRENT', popularSongCurrent);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListPopularAlbum({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const popularAlbum = await getPopularAlbum({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist, 1);
      const popularAlbumCurrent = await getPopularAlbum({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist, 0);
      commit('SET_LIST_POPULAR_ALBUM', popularAlbum);
      commit('SET_LIST_POPULAR_ALBUM_CURRENT', popularAlbumCurrent);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListTopCountry({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const response = await getListTopCountry({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isArtist);
      commit('SET_LIST_TOP_COUNTRY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListTopEarningArtist({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListTopEarningArtist({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_TOP_EARNING_ARTIST', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestArtistBalance({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const user = rootGetters['AuthModule/getUser'];
      const response = await getArtistBalance({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user.id);

      commit('SET_ARTIST_BALANCE', response.data.balance ? response.data.balance : 0);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEarningToDate({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getEarningToDate({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_EARNING_TO_DATE', response.data.earning ? response.data.earning : 0);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestTopSubscriberCountry({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getTopSubscriberCountry({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      console.log(response,'ssss')
      commit('SET_LIST_TOP_SUBSCRIBER_COUNTRY', response)
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestWeeklySubscriber({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getWeeklySubscriber({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_WEEKLY_SUBSCRIBER', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPopularAlbumByPlay({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getPopularAlbumByPlay({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_POPULAR_ALBUM_BY_PLAY', {
        current: response.data.current_year,
        all_time: response.data.all_time,
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPopularSongByPlay({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getPopularSongByPlay({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_POPULAR_SONG_BY_PLAY', {
        current: response.data.current_year,
        all_time: response.data.all_time,
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_WEEKLY_CUSTOMER(state, listWeeklyCustomer) {
    state.listWeeklyCustomer = listWeeklyCustomer;
  },
  SET_SOLD_SONG(state, listSoldSong) {
    state.listSoldSong = listSoldSong;
  },
  SET_LIST_TOP_COUNTRY(state, listTopCountry) {
    state.listTopCountry = listTopCountry;
  },
  SET_LIST_POPULAR_SONG(state, listPopularSong) {
    state.listPopularSong = listPopularSong;
  },
  SET_LIST_POPULAR_SONG_CURRENT(state, listPopularSongCurrent) {
    state.listPopularSongCurrent = listPopularSongCurrent;
  },
  SET_LIST_POPULAR_ALBUM(state, listPopularAlbum) {
    state.listPopularAlbum = listPopularAlbum;
  },
  SET_LIST_POPULAR_ALBUM_CURRENT(state, listPopularAlbumCurrent) {
    state.listPopularAlbumCurrent = listPopularAlbumCurrent;
  },
  SET_LIST_TOP_EARNING_ARTIST(state, listTopEarningArtist) {
    state.listTopEarningArtist = listTopEarningArtist;
  },
  SET_LIST_TOP_SUBSCRIBER_COUNTRY(state, listTopSubscriberCountry) {
    state.listTopSubscriberCountry = listTopSubscriberCountry;
  },
  SET_LIST_WEEKLY_SUBSCRIBER(state, listWeeklySubscriber) {
    state.listWeeklySubscriber = listWeeklySubscriber;
  },
  SET_EARNING_TO_DATE(state, earningToDate) {
    state.earningToDate = earningToDate;
  },
  SET_ARTIST_BALANCE(state, artistBalance) {
    state.artistBalance = artistBalance;
  },
  SET_POPULAR_ALBUM_BY_PLAY(state, {current,all_time}) {
    state.listPopularAlbumByPlay = all_time;
    state.listPopularAlbumCurrentByPlay = current;
  },
  SET_POPULAR_SONG_BY_PLAY(state, {current,all_time}) {
    state.listPopularSongByPlay = all_time;
    state.listPopularSongCurrentByPlay = current;
  },
};

export default {
  namespaced: true,
  state: {
    listWeeklyCustomer: [],
    listSoldSong: [],
    listTopCountry: [],
    listPopularSong: [],
    listPopularSongCurrent: [],
    listPopularSongByPlay: [],
    listPopularSongCurrentByPlay: [],
    listPopularAlbum: [],
    listPopularAlbumCurrent: [],
    listPopularAlbumByPlay: [],
    listPopularAlbumCurrentByPlay: [],
    listTopEarningArtist: [],
    listTopSubscriberCountry: [],
    listWeeklySubscriber: [],
    earningToDate: 0,
    artistBalance: 0,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Statistic/index.js